import type { Workspace } from '../types/workspace'

export type DiagnosticsAdapterMode = 'disabled' | 'memory' | 'firestore'

const normalizeMode = (value: unknown): DiagnosticsAdapterMode => {
  if (value === 'firestore' || value === 'memory' || value === 'disabled') return value
  return 'memory'
}

export const getDiagnosticsAdapterMode = (): DiagnosticsAdapterMode =>
  normalizeMode(import.meta.env.VITE_DIAGNOSTICS_MODE)

export const workspaceDiagnosticsPersistenceEnabled = (workspace?: Pick<Workspace, 'modules'> | null) =>
  getDiagnosticsAdapterMode() === 'firestore' && workspace?.modules?.diagnosticsEnabled === true

export const diagnosticsDeepLocalModeEnabled = () =>
  import.meta.env.DEV && import.meta.env.VITE_DIAGNOSTICS_DEEP_LOCAL === 'true'
